// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"7af457ed","782":"368ae710"}[chunkId] + ".chunk.js";
};